import { render, staticRenderFns } from "./PaymentCancelNew.vue?vue&type=template&id=6fc95054&scoped=true&"
import script from "./PaymentCancelNew.vue?vue&type=script&lang=js&"
export * from "./PaymentCancelNew.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCancelNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PaymentCancelNew.vue?vue&type=style&index=1&id=6fc95054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc95054",
  null
  
)

export default component.exports